import { useState } from 'react'
import { X, Mail, User, Building2, Briefcase, Loader2, CheckCircle } from 'lucide-react'
import './RegisterForm.css'

function RegisterForm({ onClose }) {
    const [formData, setFormData] = useState({
        nombre: '',
        cargo: '',
        email: '',
        empresa: ''
    })
    const [isLoading, setIsLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState('')

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
        setError('')
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        setError('')

        try {
            const response = await fetch('/api/auth/register.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })

            const data = await response.json()

            if (response.ok) {
                setSuccess(true)
            } else {
                setError(data.error || 'Error al registrar. Intente nuevamente.')
            }
        } catch (err) {
            setError('Error de conexión. Intente nuevamente.')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content glass-card" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>
                    <X size={24} />
                </button>

                {success ? (
                    <div className="success-message">
                        <div className="success-icon">
                            <CheckCircle size={64} />
                        </div>
                        <h2>¡Registro Exitoso!</h2>
                        <p>
                            Hemos enviado una contraseña temporal a tu correo electrónico
                            <strong> {formData.email}</strong>.
                            Revisa tu bandeja de entrada para iniciar sesión.
                        </p>
                        <button className="btn btn-primary" onClick={onClose}>
                            Entendido
                        </button>
                    </div>
                ) : (
                    <>
                        <div className="modal-header">
                            <h2>Únete a TerraMind</h2>
                            <p>Comienza a optimizar tu producción agrícola hoy</p>
                        </div>

                        <form onSubmit={handleSubmit} className="register-form">
                            <div className="form-group">
                                <label className="form-label">
                                    <User size={16} />
                                    Nombre Completo
                                </label>
                                <input
                                    type="text"
                                    name="nombre"
                                    className="form-input"
                                    placeholder="Ej: Juan Pérez"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">
                                    <Briefcase size={16} />
                                    Cargo
                                </label>
                                <input
                                    type="text"
                                    name="cargo"
                                    className="form-input"
                                    placeholder="Ej: Gerente de Producción"
                                    value={formData.cargo}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">
                                    <Mail size={16} />
                                    Correo Electrónico
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    className="form-input"
                                    placeholder="correo@empresa.com"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">
                                    <Building2 size={16} />
                                    Empresa
                                </label>
                                <input
                                    type="text"
                                    name="empresa"
                                    className="form-input"
                                    placeholder="Nombre de tu empresa"
                                    value={formData.empresa}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            {error && (
                                <div className="form-error">
                                    {error}
                                </div>
                            )}

                            <button
                                type="submit"
                                className="btn btn-primary btn-lg btn-full"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <Loader2 size={20} className="animate-spin" />
                                        Registrando...
                                    </>
                                ) : (
                                    'Registrarme'
                                )}
                            </button>

                            <p className="form-footer">
                                Al registrarte, aceptas nuestros términos y condiciones.
                            </p>
                        </form>
                    </>
                )}
            </div>
        </div>
    )
}

export default RegisterForm
